import axios from 'axios'

export default {
  namespaced: true,

  state: {
    token: null,
    user: null,
    loggedIn: false
  },

  getters: {
    authenticated (state) {
      return state.token && state.user
    },
    isAuthenticated (state) {
        return state.token && state.user
    },

    user (state) {
      return state.user
    }
  },

  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },

    SET_USER (state, data) {
      state.user = data
    },

    SET_LOGGEDIN (state, data) {
        state.loggedIn = data
      }
  },

  actions: {
    async signIn ({ dispatch }, credentials) {
      let response = await axios.post('auth/login', credentials)

      return dispatch('attempt', response.data.token)
    },

    async attempt ({ commit, state }, token) {
      if (token) {
        commit('SET_TOKEN', token)
      }
      
      if (!state.token) {
        return
      }

      try {
        let response = await axios.get('user/me')

        commit('SET_USER', response.data)
        commit('SET_LOGGEDIN', true)
      } catch (e) {
        commit('SET_TOKEN', null)
        commit('SET_USER', null)
        commit('SET_LOGGEDIN', false)
      }
    },

    async checkAuth( {commit, state }){

        if (state.user && state.token)
        {
            if (!state.loggedIn)
            {
                commit('SET_LOGGEDIN', true)
            }
        }else{
            commit('SET_LOGGEDIN', false)
        }
    },

    signOut ({ commit }) {
      //return axios.post('auth/signout').then(() => {
        commit('SET_TOKEN', null)
        commit('SET_USER', null)
      //})
    }
  }
}
